import React, { useState } from 'react'
import { Card, message } from 'antd'
import { CButton } from '../Common'
import { COLORS } from 'app/constants'
import UserCreateInput from './UserCreateInput'
import CreateClassificationSelect from './CreateClassificationSelect'
import PhoneSelection from './PhoneSelection'
import { useToken } from '../../hooks'
import API from '../../../utils/api'

const AdminUserCreate = ({ closeModal = () => {} }) => {
	const [selectLevel, setSelectLevel] = useState(0)
	const [nickname, setNickname] = useState('')
	const [fullname, setFullname] = useState('')
	const [email, setEmail] = useState('')
	const [phone, setPhone] = useState('')
	const [phoneCode, setPhoneCode] = useState('82')
	const [countryCode, setCountryCode] = useState('KR')
	const [password, setPassword] = useState('')
	const [referralCode, setReferralCode] = useState('')
	const { data: token } = useToken()
	const [id, setId] = useState('')
	const [bankName, setBankName] = useState('')
	const [bankAccount, setBankAccount] = useState('')

	const AddForm = () => {
		API.post('/admin/user', token + '', {
			level: selectLevel,
			nickname,
			fullname,
			loginid: id,
			email,
			phone,
			phone_code: phoneCode,
			password,
			referral_code: referralCode,
			bank_name: bankName,
			bank_account: bankAccount,
		}).then(res => {
			if (res.result.success) {
				message.success('성공')
				setSelectLevel(0)
				setNickname('')
				setFullname('')
				setEmail('')
				setId('')
				setPhone('')
				setPhoneCode('82')
				setCountryCode('KR')
				setPassword('')
				setReferralCode('')
				closeModal()
			} else {
				message.error('실패:' + res.result?.message)
			}
		})
	}

	return (
		<Card title="사용자 등록">
			<CreateClassificationSelect
				defaultValue={selectLevel}
				setSelectLevel={setSelectLevel}
			/>
			<UserCreateInput
				value={nickname}
				setValue={setNickname}
				name={'닉네임'}
				placeholder={'닉네임'}
			/>

			<UserCreateInput
				value={fullname}
				setValue={setFullname}
				name={'성명'}
				placeholder={'성명'}
			/>
			<UserCreateInput
				value={id}
				setValue={setId}
				name={'아이디'}
				placeholder={'아이디'}
			/>

			<UserCreateInput
				value={email}
				setValue={setEmail}
				name={'이메일'}
				placeholder={'이메일'}
			/>

			<UserCreateInput
				value={bankName}
				setValue={setBankName}
				name={'은행'}
				placeholder={'은행명'}
			/>

			<UserCreateInput
				value={bankAccount}
				setValue={setBankAccount}
				name={'은행계좌'}
				placeholder={'은행계좌'}
			/>

			<PhoneSelection
				phone={phone}
				setPhone={setPhone}
				phoneCode={phoneCode}
				setPhoneCode={setPhoneCode}
			/>

			<UserCreateInput
				value={password}
				setValue={setPassword}
				name={'암호'}
				placeholder={'암호'}
			/>

			<UserCreateInput
				value={referralCode}
				setValue={setReferralCode}
				name={'그룹추천코드'}
				placeholder={'그룹추천코드'}
			/>

			<CButton
				title={'저장'}
				onClick={AddForm}
				style={{
					background: COLORS.primary,
					width: '100%',
					height: 30,
					color: COLORS.white,
				}}
			/>
		</Card>
	)
}

export default AdminUserCreate
